import { cloneDeep } from '@apollo/client/utilities';
import { CompanyEntity } from '../common/entity';

export class ContainerType extends CompanyEntity {
  name!: string;

  constructor(obj: any) {
    if (!obj.companyId) return;
    super(obj.companyId);
    Object.assign(this, cloneDeep(obj));
  }
}
